import { createRoute } from '@tanstack/solid-router'
import { appLayoutRoute } from '../app-layout.route'
import { KnbkAssetsPage } from '../../KnbkAssetsPage'

// Галерея ассетов КНБК (иконки элементов колонны), извлечённых из
// design_ref/source/КНБК №1.xlsx. Без search-параметров — чисто read-only вью.
export const knbkAssetsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/knbk-assets',
  component: KnbkAssetsPage,
})
